import {CORE_AUTH_DOMAIN} from '~/constants/authorize';
import {isoWindow} from '~/utils/window';

export const LEGAL_LINKS = [
  {
    key: 'affirmCanadaHelpLink',
    href: 'https://www.affirm.ca/help',
    text: 'affirm.ca/help',
  },
  {
    key: 'lendersLink',
    href: 'https://www.affirm.com/lenders',
    text: 'affirm.com/lenders',
  },
  {
    key: 'licensesLink',
    href: 'https://www.affirm.com/licenses',
    text: 'affirm.com/licenses',
  },
];

// Currencies that don't use decimal places in their amounts
// https://docs.stripe.com/currencies#zero-decimal
export const ZERO_DECIMALS_CURRENCIES = [
  'BIF',
  'CLP',
  'DJF',
  'GNF',
  'HUF',
  'ISK',
  'JPY',
  'KMF',
  'KRW',
  'MGA',
  'PYG',
  'RWF',
  'TWD',
  'UGX',
  'VND',
  'VUV',
  'XAF',
  'XOF',
  'XPF',
];

export const AFFIRM_SUPPORTED_LOCALES_BY_COUNTRY_CODE: Record<
  string,
  string[]
> = {
  CA: ['en', 'fr'],
};

export const DEFAULT_AFFIRM_SUPPORTED_LOCALE = 'en';

export const OVERLAY_URL = `${CORE_AUTH_DOMAIN}/shopify_pay/prequal_authorize?target_origin=${isoWindow.location.origin}`;
